/**
 * Мобильная навигация водителя.
 *
 * Ровно четыре пункта — требование брифа. Прежний navItems.js давал
 * шесть (Главная, Машины, Поездки, Задачи, Помощь, Профиль) и использовал
 * эмодзи как иконки.
 *
 * Машины, Помощь и Профиль переехали в «Ещё»: это не ежедневные
 * действия водителя, а справочные и настроечные разделы.
 *
 * Не добавлять сюда пункты без явного UX-обоснования.
 */
export const DRIVER_TABS = [
  { to: '/', icon: 'home', label: 'Главная', end: true },
  { to: '/trips', icon: 'trips', label: 'Поездки' },
  { to: '/tasks', icon: 'tasks', label: 'Задачи' },
  { to: '/more', icon: 'more', label: 'Ещё' },
]

/** Разделы внутри «Ещё». */
export const MORE_ITEMS = [
  // Чат живёт в развороте «Ещё» (решение продукта): нижняя навигация
  // остаётся четырёхпунктовой, тикеты не трогаются. Перенос в таббар —
  // отдельное решение, когда чат станет основным каналом.
  { to: '/chat', icon: 'chat', label: 'Чат', hint: 'Диспетчер и группы' },
  { to: '/chat/saved', icon: 'bookmark', label: 'Сохранённое', hint: 'Важные сообщения' },
  // Экран сам показывает заглушку, если владелец выключил модуль:
  // прятать пункт по асинхронной настройке — мигающее меню.
  { to: '/video', icon: 'chat', label: 'Видеозвонки', hint: 'Осмотры и планёрки' },
  { to: '/notifications', icon: 'bell', label: 'Уведомления', hint: 'Пуши о сообщениях' },
  { to: '/cars', icon: 'car', label: 'Машины', hint: 'Доступный автопарк' },
  { to: '/queue', icon: 'trips', label: 'Ожидают отправки', hint: 'Что ещё не ушло на сервер' },
  { to: '/kb', icon: 'file', label: 'База знаний', hint: 'Инструкции и регламенты' },
  { to: '/support', icon: 'wrench', label: 'Поддержка', hint: 'Вопросы и обращения' },
  { to: '/profile', icon: 'users', label: 'Профиль', hint: 'Документы и настройки' },
]
